import { render } from "./WindowChecker.vue?vue&type=template&id=b9c10708"
import script from "./WindowChecker.vue?vue&type=script&lang=js"
export * from "./WindowChecker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__